module.exports = __webpack_public_path__ + "img/content-img1_2.514e7045.png";